import { render } from "./widget_management.html?vue&type=template&id=996efa36&external"
import script from "./widget_management.js?vue&type=script&lang=js&external"
export * from "./widget_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__